/**
 * OpenChartButton (R149) — the single, professional "open chart" control used
 * across every Dashboard section, rendered as its own narrow column right
 * after the Symbol so it's easy to find and uniform everywhere.
 *
 * A tinted rounded button that fills with the primary colour on hover, with a
 * consistent tooltip — replacing the assorted bare CandlestickChartIcon usages.
 */
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart';

interface Props {
  onOpen: () => void;
  /** Stop row click-through (rows that are themselves clickable). */
  stopPropagation?: boolean;
  /** Icon glyph size (px). */
  size?: number;
  title?: string;
}

const OpenChartButton: React.FC<Props> = ({ onOpen, stopPropagation = true, size = 16, title = 'Open chart in new tab' }) => (
  <Tooltip title={title} arrow>
    <IconButton
      size="small"
      onClick={(e) => { if (stopPropagation) e.stopPropagation(); onOpen(); }}
      sx={{
        p: 0.35,
        borderRadius: 1,
        color: 'primary.main',
        bgcolor: 'action.hover',
        border: theme => `1px solid ${theme.palette.divider}`,
        transition: 'background-color 120ms ease, color 120ms ease',
        '&:hover': { bgcolor: 'primary.main', color: 'primary.contrastText', borderColor: 'primary.main' },
      }}
    >
      <CandlestickChartIcon sx={{ fontSize: size }} />
    </IconButton>
  </Tooltip>
);

export default OpenChartButton;
